import { Component, Input, OnInit } from '@angular/core';
import { PICKUP_PLANNING_CARD_CHIPS, TRAFFIC_FLOW_DESCRIPTIONS } from '../../../configuration/consts/pickupPlanning';
import { ChipComponent } from '@nagel-components';
import { InfoLotChip } from 'apps/nagel-cal-disposition/src/models/planningPageTypes';


type PrefixType = {
  label?: string;
  icon?: string;
}

const {
    WEIGHT,
    VOLUME_PALLET_SPACES,
    FLOOR_PALLET_SPACES,
    DELIVERY_DATE_FROM,
    DELIVERY_DATE_TO,
    PLANNED_TIME,
    PEOPLE,
    TRAFFIC_FLOW,
    PARKING,
    AMBIENT,
    EXECUTION_INTERVAL,
    FRESH,
    ULTRA_FRESH,
    DRY,
    LIQUID,
    FRUITS_AND_VEGETABLES,
    FROZEN
}  = PICKUP_PLANNING_CARD_CHIPS;

const temperatureChips = [FRESH, ULTRA_FRESH, DRY, LIQUID, FRUITS_AND_VEGETABLES, FROZEN, AMBIENT];

//TODO: Fix map when real data is given based on field name
const prefixMap: Record<string, PrefixType> = {
    [WEIGHT]: {
        icon: 'weight_icon'
    },
    [VOLUME_PALLET_SPACES]: {
        label: 'VSP'
    },
    [FLOOR_PALLET_SPACES]: {
        label: 'BSP'
    },
    [DELIVERY_DATE_FROM]: {
        icon: 'departure_calendar_icon'
    },
    [DELIVERY_DATE_TO]: {
        icon: 'arrival_calendar_icon'
    },
    [PLANNED_TIME]: {
        icon: 'clock_icon'
    },
    [PEOPLE]: {
        icon: 'person_icon'
    },
    [TRAFFIC_FLOW]: {
        label: 'VK'
    },
    [PARKING]: {
        icon: 'parking_icon'
    },
    [AMBIENT]: {
        icon: 'air_conditioner_icon'
    },
    [EXECUTION_INTERVAL]: {
        icon: 'date_range_icon'
    },
    [FRESH]: {
        icon: 'strawberry_icon'
    },
    [ULTRA_FRESH]: {
        icon: 'citrus_icon'
    },
    [DRY]: {
        icon: 'leaf_icon'
    },
    [FROZEN]: {
        icon: 'snowflake_icon'
    },
    [LIQUID]: {
        icon: 'drop_icon'
    },
    [FRUITS_AND_VEGETABLES]: {
        icon: 'apple_icon'
    }
};

@Component({
    selector: 'cal-draggable-card-info-chip',
    imports: [ChipComponent],
    templateUrl: './draggable-card-info-chip.component.html',
    styleUrl: './draggable-card-info-chip.component.scss',
    host: {
        '[attr.data-tooltip]': 'tooltip'
    }
})
export class DraggableCardInfoChipComponent implements OnInit {
    @Input() chip!: InfoLotChip;
    @Input() className?: string;

    icons: string[] = [];
    label = '';
    tooltip: string | null = null;

    prefix: PrefixType = { label: '' };
    multiplePrefixes: string[] = [];

    ngOnInit() {
        if ((this.chip.multipleNames || []).length) {
            this.icons = (this.chip.multipleNames || []).map((name) => prefixMap[name].icon || '');
        } else {
            const prefix = prefixMap[this.chip.name] || {};
            this.icons = prefix.icon ? [prefix.icon] : [];
            this.label = prefix.label || '';
            this.chip.label = this.getChipLabel();
            this.tooltip = this.getTooltip();
        }
    }

    getTooltip = (): string | null => {
        if (String(this.chip.name) !== TRAFFIC_FLOW) {
            return null;
        }

        const descriptions = String(this.chip.label ?? '')
            .split(',')
            .map((trafficFlow) => TRAFFIC_FLOW_DESCRIPTIONS[trafficFlow.trim()])
            .filter(Boolean);

        return descriptions.length ? descriptions.join('\n') : null;
    };

    getChipLabel = () => {
        return temperatureChips.includes(this.chip.name) ? this.chip.label : (this.chip.label || '--');
    };

    getClassName = () => {
        return 'draggable-card-info-chip relative text-center mt-1 mb-1 mr-1 rounded-2xl overflow-hidden !flex text-xs ' + this.className;
    };
}